<template>
  <div id="app">
    <Top v-if="!routeIsRoot" />
    <User />
    <Session v-if="isAppIdle && userLoggedIn()" />
    <notifications group="general" position="top left" />
    <transition name="slide-fade">
      <router-view class="view" />
    </transition>
    <Bottom v-if="!routeIsRoot" />
  </div>
</template>

<script>
import Top from '../src/components/Top'
import Bottom from '../src/components/Bottom'
import User from '../src/components/User'
import Session from '../src/components/Session'

export default {
  name: 'App',
  components: {
    Top,
    Bottom,
    User,
    Session
  },
  created () {
    document.title = sessionStorage.getItem('language') === 'en' ? 'Diabetes support' : 'Diabetessupporten'
  },
  methods: {
    userLoggedIn () {
      return this.$store.getters.getLogin || sessionStorage.getItem('userLoggedIn')
    }
  },
  computed: {
    routeIsRoot () {
      return this.$route.path === '/'
    }
  }
}
</script>

<style>
html {
  overflow-x: hidden;
}
[v-cloak] {
  display: none !important;
}
/* Scroll */
::-webkit-scrollbar {
  width: 7px;
}
::-webkit-scrollbar-track {
  background: #001965;
}
::-webkit-scrollbar-thumb {
  background: #001965;
}
::-webkit-scrollbar-thumb:hover {
  background: #122e80;
}
#app {
  font-family: 'Montserrat', sans-serif;
  font-style: normal;
  font-weight: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
}
h1, h2, h3, h4 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a, a:hover {
  text-decoration: none !important;
}
a:hover::first-letter {
  text-decoration: underline !important;
}
p {
  text-align: left;
}
hr {
  margin-top: 0;
}
.clearfix {
  margin: 15px;
}
.clearfix--min {
  margin: 6px;
}
.clearfix--mid {
  margin: 40px;
}
.clearfix--max {
  margin: 100px;
}
.m-w-150 {
  min-width: 150px;
}
.container {
  margin-bottom: 0vh;
  margin-top: 7vh;
  min-height: 85vh;
  min-width: 100vw;
  padding-top: 9vh;
  padding-bottom: 4vh;
  background: #eaecf047 !important;
}
.progress {
  margin-bottom: 2rem;
}
.left {
  float: left !important;
}
.right {
  float: right !important;
}
.text-center {
  text-align: center !important;
  margin-left: auto !important;
  margin-right: auto !important;
}
.cursor-pointer {
  cursor: pointer;
}
.loading-text {
  margin-top: 22vh;
  position: absolute;
  background: #f4f0f0d4;
  border-radius: 10px;
  padding: 30px;
}
.watermark {
  display: none; /* 2023-07-15: remove this if watermark to be reestablished */
  -webkit-transform: rotate(333deg);
  -moz-transform: rotate(333deg);
  -o-transform: rotate(333deg);
  transform: rotate(333deg);
  font-size: 3em;
  margin-top: 6vh;
  text-align: center;
  font-weight: bold;
  color: rgba(255, 5, 5, 0.45);
  position: absolute;
}
.watermark:hover {
  color: rgba(255, 5, 5, 0.1);
  cursor: default;
}
/* Portrait and Landscape */
@media only screen
  and (min-device-width: 300px)
  and (max-device-width: 812px) {
    .card {
      margin: 20px;
    }
    .img {
      width: 22vw !important;
    }
    .loading-text {
      margin-top: 25vh;
    }
}
@media screen and (-webkit-min-device-pixel-ratio:0) {
  select,
  textarea,
  input {
    font-size: 16px;
  }
}
/* route transition */
.slide-fade-enter-active {
  transition: all .5s ease;
}
.slide-fade-leave-active {
  transition: all .5s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to{
  transform: translateX(10px);
  opacity: 0;
}
/* bootstrap override */
.mark {
  background: #e200008e !important;
  margin: 30px;
  padding: 30px;
  border-radius: 10px;
}
.modal-open::-webkit-scrollbar {
  width: 1px !important;
}
.modal-content {
  border-radius: 40px;
}
.modal-header {
  background: #C0E1FA !important;
}
.modal-body {
  background: #C0E1FA !important;
  border-radius: 40px;
  padding: 2rem;
}
.close {
  margin-top: -1vh;
  font-size: 40px !important;
}
.card {
  padding: 20px;
  border-radius: 10px;
  min-height: 66vh;
  margin-top: 3vh;
  background: #C0E1FA !important;
}
.btn {
  border-radius: 20px !important;
}
.btn-primary {
  background: #3B97DE !important;
  border: 0 !important;
  color: #fff;
}
.btn-primary:not(:disabled):not(.disabled):hover {
  color: #fff !important;
  background: #001965 !important;
}
.navbar-toggler {
  border-color: transparent !important;
}
.btn-link {
  text-decoration: none !important;
  line-height: 5px;
  padding-bottom: 15px;
  color: rgba(0, 0, 0, 0.503);
  font-size: 40px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue